import { Cell, Pie, PieChart } from "recharts";
import { Stack, Typography } from "@mui/material";
import React from "react";

const renderCustomizedLabel = (props) => {
  if (
    props.cx == null ||
    props.cy == null ||
    props.innerRadius == null ||
    props.outerRadius == null
  ) {
    return null;
  }
  // console.log(props);
  return props.name === "Defects" ? (
    <text
      x={props.cx}
      y={props.cy}
      fill="black"
      textAnchor={"middle"}
      dominantBaseline="central"
      style={{ fontSize: "36px", fontWeight: "bold", fontFamily: "Roboto" }}
    >
      {props.value}
    </text>
  ) : null;
};

export default function DonutChartView({ count, total, color, title }) {
  const [data] = React.useState([
    { order: 1, name: "Defects", value: count, color: color },
    {
      order: 2,
      name: "No Defects",
      value: total - count,
      color: "#C0C0C0",
    },
  ]);

  return (
    <Stack
      direction="column"
      spacing={1}
      sx={{
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <PieChart
        className="RechartsHide"
        style={{
          height: "14vh",
          marginLeft: 6,
          width: "14vh",
          position: "relative",
        }}
        responsive
      >
        <Pie
          data={data}
          labelLine={false}
          label={renderCustomizedLabel}
          fill="#8884d8"
          dataKey="value"
          startAngle={90}
          endAngle={-270}
          outerRadius="80%"
          innerRadius="60%"
          isAnimationActive={true}
          style={{ outline: "none" }}
        >
          {data
            .slice()
            .sort((a, b) => a.order - b.order)
            .map((entry, index) => (
              <Cell
                key={index}
                fill={entry.color}
                style={{ outline: "none" }}
              />
            ))}
        </Pie>
        <Stack
          direction="row"
          spacing={0}
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
        ></Stack>
      </PieChart>
      <Typography variant="body2" fontWeight={700}>
        {title}
      </Typography>
    </Stack>
  );
}
